import { render, staticRenderFns } from "./LiberarAsiento.vue?vue&type=template&id=30ddbf62"
import script from "./LiberarAsiento.vue?vue&type=script&lang=js"
export * from "./LiberarAsiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports